export default "__VITE_ASSET__CjWF3eOD__"